// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2oKyv","info":"Note_info__1nHCP","note":"Note_note__191JX","actions":"Note_actions__18cin"};